<nx-headline-box class="mb-[1.25rem]"
  appearance="underline"
  [label]="'orderModule.orderOperatedRentalDetailsComponent.headlines.details' | translate">
</nx-headline-box>

<nx-headline-box
  [label]="'orderModule.orderOperatedRentalDetailsComponent.headlines.orderData' | translate">
</nx-headline-box> 
<div class="mb-2">
  <div class="flex flex-col">
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderOperatedRentalDetailsComponent.details.orderNumber' | translate">
      {{order?.number}}
    </nx-default-box>
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderOperatedRentalDetailsComponent.details.type' | translate">
      {{Order.getOrderType(order?.type?.toString()) | translate}}
    </nx-default-box>
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderOperatedRentalDetailsComponent.details.location' | translate">
      {{order?.location?.name}}
    </nx-default-box>
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderOperatedRentalDetailsComponent.details.automaticArchive.label' | translate">
      {{(order?.archive ? 'orderModule.orderOperatedRentalDetailsComponent.details.automaticArchive.true' : 'orderModule.orderOperatedRentalDetailsComponent.details.automaticArchive.false') | translate}}
    </nx-default-box>
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderOperatedRentalDetailsComponent.details.customerNumber' | translate">
    <div class="flex items-center">
      <a [routerLink]="['/customers/customer/', order?.customer?.id ]" class="jump">
        {{order?.customer?.getFullName()? order?.customer?.getFullName() :'-'}} {{order?.customer?.number? '(' +
        order?.customer.number+ ')': ''}}
        <i [className]="'icon icon-jump-to'"></i>
      </a>
    </div>
  </nx-default-box>
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderOperatedRentalDetailsComponent.details.customerOrderNumber' | translate">
      {{order?.customerOrderNumber}}
    </nx-default-box>
    
    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderOperatedRentalDetailsComponent.details.ordererName' | translate">
      {{order?.orderer?.getFullName()}}
    </nx-default-box>

    <nx-default-box class="bg-white border-b border-gray"
      [label]="'orderModule.orderOperatedRentalDetailsComponent.details.note' | translate">
      {{order?.note}}
    </nx-default-box>
  </div>
</div>

<div *ngFor="let section of customSections; let index = index; let isLast = last" class="mb-2">
  
  <nx-headline-box
    [label]="section?.label">
  </nx-headline-box> 

  <nx-default-box
    *ngFor="let defintion of section?.customAttributeDefinitions; let isLast = last"
    class="bg-white border-b border-gray"
    [label]="defintion?.label">
    <ng-container
      *ngIf="defintion?.type !== 'DATETIME'">
      {{getValue(defintion?.id)}}
    </ng-container>
    <ng-container
      *ngIf="defintion?.type === 'DATETIME'">
      (getValue(defintion?.id) | date:'dd.MM.yyyy HH:mm')
    </ng-container>
  </nx-default-box>

</div>